// @flow
import React from 'react';
import Swiper from 'react-id-swiper';

import buttonPrev from '../../../assets/images/icons/navigation-left.svg';
import buttonNext from '../../../assets/images/icons/navigation-right.svg';

import './style.pcss';

const withSliderLayout = (items: React$Element<'div'>[], {
  color
}: {
  color: string,
}) => {
  const swiperParams = {
    slidesCount: items.length,
    color,
    class: '',
    navigation: {
      nextEl: items.length !== 1 ? '.banner-swiper-button-next' : null,
      prevEl: items.length !== 1 ? '.banner-swiper-button-prev' : null
    },
    renderNextButton: () => (
      items.length > 1 ? (
        <button
          className='swiper-button-next banner-swiper-button-next'
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: buttonNext }}
        />
      )
        : null
    ),
    renderPrevButton: () => (
      items.length > 1 ? (
        <button
          className='swiper-button-prev banner-swiper-button-prev'
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: buttonPrev }}
        />
      )
        : null
    ),
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      dynamicBullets: false,
      renderBullet(index, className) {
        return items.length !== 1 ? `<span style="background-color: ${color}" class="${className}"> </span>` : '';
      }
    },
    rebuildOnUpdate: true,
    initialSlide: 0,
    on: {
      init() {
        // eslint-disable-next-line react/no-this-in-sfc
        this.allowTouchMove = this.params.slidesCount > 1;
      }
    },
    centeredSlides: true,
    slidesPerView: 'auto',
    loopedSlides: 0,
    loopAdditionalSlides: 0
  };

  return (
    <div className='slider-layout'>
      <Swiper
        {...swiperParams}
        containerClass={`swiper-container banner-container ${swiperParams.class}`}
      >
        {items.map(item => item)}
      </Swiper>
    </div>
  );
};

export default withSliderLayout;
